import { render, staticRenderFns } from "./SalesSummaryCards.vue?vue&type=template&id=35ddf290&scoped=true"
import script from "./SalesSummaryCards.vue?vue&type=script&lang=js"
export * from "./SalesSummaryCards.vue?vue&type=script&lang=js"
import style0 from "./SalesSummaryCards.vue?vue&type=style&index=0&id=35ddf290&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ddf290",
  null
  
)

export default component.exports